import LandingPageHeroBlack, {
  LandingPageHeroBlackProps
} from '../../../../components/_external-pages/landing/LandingPageHeroBlack';

const props: LandingPageHeroBlackProps = {
  title: 'Lo decimos nosotros y nuestros clientes',
  titleStyle: {
    color: 'common.black'
  },
  boxBlurStyle: {
    color: 'common.black',
    backgroundColor: 'rgba(145, 158, 171, 0.12)'
  },
  cards: [
    {
      name: 'Cesar Gonzalez',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'La atencion y recibimiento es muy grato y genera mucha confianza en la empresa.'
    },
    {
      name: 'Josue Sumuano',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'La mejor alternativa. No me cobró comisión por apertura!!!'
    },
    {
      name: 'Rogelio Arturo Hernandez',
      icon: '/static/icons/star.svg',
      rate: 5,
      comment: 'Súper recomendable!! Excelente trato al cliente.'
    }
  ]
};

export const AboutHeroInPageBlack = () => {
  return <LandingPageHeroBlack {...props} />;
};
